import React from "react";
import Subtract from "../assets/Subtract.svg";
import X from "../assets/X.svg";
import Youtube from "../assets/youtube.svg";
import { scroller } from "react-scroll";

import { Link as NavLink } from "react-router-dom";
import { useLocation, useNavigate } from "react-router-dom";
export default function Footer() {
  const location = useLocation();
  const navigate = useNavigate();
    const handleNav = (section) => {
      if (location.pathname === "/") {
        scroller.scrollTo(section, {
          smooth: true,
          duration: 600,
          offset: -80,
        });
      } else {
        navigate("/", {
          state: { scrollTo: section },
        });
      }
    };
  return (
    <footer className="bg-[#ebe2d5] text-[#8b5e3c] text-sm">
      <div className="max-w-6xl mx-auto px-4 py-10">
        <div className="flex flex-col gap-10 border-b border-[#d3c6b5] pb-8">
          <div className="flex flex-col sm:flex-row justify-between items-center gap-3 border-b border-[#d3c6b5] pb-2">
            <NavLink to="/">
              <div className="cursor-pointer flex items-center space-x-2 mb-1 sm:mb-0">
                <img
                  src={Subtract}
                  alt="agoravoice.ai"
                  className="h-[32px] w-[32px]"
                />
                <span className="font-semibold text-[22px] text-[#1C1C1C]">
                  agoravoice.ai
                </span>
              </div>
            </NavLink>

            <div className="w-full sm:w-auto text-center sm:text-right">
              <p className="text-xs text-[#8B0000] leading-tight">
                The Digital Voice for <br className="hidden sm:block" />{" "}
                Every Place
              </p>
            </div>
          </div>

          <div className="flex flex-col items-center md:flex-row justify-between flex-wrap gap-10 pb-5 text-xs">
            <div className="flex flex-wrap gap-10">
              <div>
                <h3 className="font-bold mb-3 text-[#8B0000]">PRODUCT</h3>
                <ul className="space-y-3 text-[#B15454]">
                  <li
                    onClick={() => handleNav("features")}
                    className="hover:text-[#df0808] cursor-pointer"
                  >
                    Features
                  </li>
                  <li
                    onClick={() => handleNav("usecase")}
                    className="hover:text-[#df0808] cursor-pointer"
                  >
                    Use Cases
                  </li>
                  <li
                    onClick={() => handleNav("howItWorks")}
                    className="hover:text-[#df0808] cursor-pointer"
                  >
                    How it Works
                  </li>
                  <li
                    onClick={() => handleNav("pricing")}
                    className="hover:text-[#df0808] cursor-pointer"
                  >
                    Pricing
                  </li>
                </ul>
              </div>

              <div>
                <h3 className="font-bold mb-3 text-[#8B0000]">RESOURCES</h3>
                <ul className="space-y-3 text-[#B15454]">
                  <li>
                    <NavLink
                      to="/"
                      className="hover:text-[#df0808] cursor-pointer"
                    >
                      Documentation
                    </NavLink>
                  </li>
                  <li>
                    <NavLink
                      to="/blogs"
                      className="hover:text-[#df0808] cursor-pointer"
                    >
                      Blog
                    </NavLink>
                  </li>
                  <li>
                    <NavLink
                      to="/help"
                      className="hover:text-[#df0808] cursor-pointer"
                    >
                      FAQs
                    </NavLink>
                  </li>
                </ul>
              </div>
              <div>
                <h3 className="font-bold mb-3 text-[#8B0000]">COMPANY</h3>
                <ul className="space-y-3 text-[#B15454]">
                  <li>
                    <NavLink
                      to="/about-us"
                      className="hover:text-[#df0808] cursor-pointer"
                    >
                      About Us
                    </NavLink>
                  </li>
                  <li>
                    <NavLink
                      to="/"
                      className="hover:text-[#df0808] cursor-pointer"
                    >
                      Careers
                    </NavLink>
                  </li>
                  <li>
                    <NavLink
                      to="/contact-us"
                      className="hover:text-[#df0808] cursor-pointer"
                    >
                      Contact Us
                    </NavLink>
                  </li>
                </ul>
              </div>
            </div>

            <div className="flex flex-col items-center md:items-end gap-6 w-full sm:w-auto">
              <div className="flex space-x-3 justify-center sm:justify-end">
                <a
                  href="https://x.com/AgoraVoiceAI"
                  target="_blank"
                  rel="noreferrer"
                  className="p-2 bg-white rounded-2xl hover:bg-[#d3c6b5] transition"
                >
                  <img src={X} alt="X" className="h-[24px] w-[24px]" />
                </a>
                <a
                  href="https://www.youtube.com/channel/UC6uFGW8ZU4TqfzMg2CaRWVA"
                  target="_blank"
                  rel="noreferrer"
                  className="p-2 bg-white  rounded-2xl hover:bg-[#d3c6b5] transition"
                >
                  <img
                    src={Youtube}
                    alt="YouTube"
                    className="h-[24px] w-[24px]"
                  />
                </a>
              </div>
              <a
                href="https://app.agoravoice.ai"
                target="_blank"
                style={{ fontSize: "16px" }}
                className={`text-center  hover:from-[#B22222] hover:to-[#B22222]  bg-gradient-to-r from-[#B22222] to-[#FF4D4D]  font-semibold    text-white p-[11px] rounded-full`}
                rel="noreferrer"
              >
                Get Started
              </a>
            </div>
          </div>
        </div>

        {/* Bottom bar */}
        <div className="flex flex-col md:flex-row justify-between items-center py-2 text-xs text-[#b07c55] text-center md:text-left">
          <p>© 2025 AgoraVoice.ai. All rights reserved.</p>
          <div className="flex space-x-3 mt-2 md:mt-0">
            <a href="/terms-of-service">Terms of Service</a>
            <a href="/privacy-policy">Privacy</a>
          </div>
        </div>
      </div>
    </footer>
  );
}
